<template>
  <div class="app-shell">
    <GlobalAtmosphere class="layer-atmosphere" />
    <div class="app-page-layer">
      <NuxtPage />
    </div>
  </div>
</template>

<script setup>
useHead({
  htmlAttrs: {
    lang: 'zh-CN'
  },
  script: [
    {
      key: 'theme-init',
      children: `(function(){var setTheme=function(v){var h=document.documentElement;if(h){h.classList.remove('dark','light');h.classList.add(v);}var b=document.body;if(b){b.classList.remove('dark','light');b.classList.add(v);}};try{var t=localStorage.getItem('theme');var d=window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light';var v=t||d;setTheme(v);if(!document.body){document.addEventListener('DOMContentLoaded',function(){setTheme(v);},{once:true});}}catch(e){setTheme('dark');if(!document.body){document.addEventListener('DOMContentLoaded',function(){setTheme('dark');},{once:true});}}})();`
    }
  ]
})
</script>
